import { render } from "./PaymentTypes.vue?vue&type=template&id=a72fed6a"
import script from "./PaymentTypes.vue?vue&type=script&lang=js"
export * from "./PaymentTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__